import { render, staticRenderFns } from "./PageCanvas.vue?vue&type=template&id=80df5fde&"
import script from "./PageCanvas.vue?vue&type=script&lang=js&"
export * from "./PageCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PageCanvas.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports